export const mockEnderecos = [
  {
    cep: "90150070",
    tipoLogradouro: "Avenida",
    logradouro: "Ganzo",
    bairro: "Menino Deus",
    cidade: "Porto Alegre",
    uf: "RS",
  },
  {
    cep: "18055087",
    tipoLogradouro: "Rua",
    logradouro: "João Thomé Franco",
    bairro: "Wanel Ville",
    cidade: "Sorocaba",
    uf: "SP",
  },
  {
    cep: "18125000",
    cidade: "Alumínio",
    uf: "SP",
  },
];
